<script>
import { notify } from '@/helpers/notify' 
import Datatable from '@/components/Datatable'
import datatableMixin from '@/helpers/mixins/datatableMixin'

export default {
    name: 'ClientList',
    props:[
        "modelOpen",
        "apartmanetId",
        "apartmentName"
    ],
    components: {
        Datatable
    },
    mixins: [ datatableMixin ],
    data() {
        return {
            form: {},
            submitted: false,
            loading: true,
            columns: [
                { name: 'Kullanıcı Adı', key: 'username', width: 150, orderable: false },
                { name: 'İsim Soyisim', key: 'fullname',  width: 150},
                { name: 'Bitiş Tarihi', key: 'expiredate', className: 'text-end', width: 150, orderable: true  },
                { name: 'Telefon1', key: 'phonenumber', className: 'text-end', width: 150, orderable: false },
                { name: 'Telefon2', key: 'phonenumber2', className: 'text-end', width: 150, orderable: false },
                { name: '', key: 'button', className: 'text-end', orderable: false },
            ],
            tableData: {
                data: [],
                pagination: {},
                detail: false,
                excel: false, 
                searchable:{
                    visible:true,
                    placeholder:"İsim Soyisim Ara"
                }
            },
            isLoading: false,
            pageLoading: false,
            params: {
                per_page: 50,
                page: 1 
            },
            sort: { column: 'expiredate', order:'desc'},
            searchQuery: '',
            pagination:'pagination',
            name:'',
         };
    },
    watch:{
        modelOpen(){
                 
            if(this.apartmentName){
                this.name = this.apartmentName
            }else{
                this.$http.post('/apartman', { apartmentId: this.apartmanetId })
                .then(response =>  this.name = response.data.name )
            }
           
            this.rows = []
            this.searchParams = {apartmentId: this.apartmanetId}
            this.loadPage(); 
        },
    },
    methods: {
       
        async loadPage() {
            this.isLoading = true 
            const response = await  this.$http.post(`/apartman/customers-under-apt`, { params: this.params, sort:this.sort, search_query: this.searchQuery,  search_params: this.searchParams  });
            this.tableData.data = response.data.data;
            this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
            this.isLoading = false
        },

        close(){
            this.$parent.$bvModal.hide('client-list-scoped')
        },

        label(status){

           
            let labelColor = ''
            let label = ''
        

            switch (status) {
                case 1:
                    labelColor = '#7eff7e'
                    label = 'Aktif'
                    break;
                case 2:
                    labelColor = '#0064ff47'
                    label = 'Süresi Bitmiş'
                    break;
                case 3:
                    labelColor = '#ffff005e'
                    label = 'Sökülmüş'
                    break;
                case 4:
                    labelColor = '#c3c3c39e'
                    label = 'Dondurulmuş'
                    break;
                case 6:
                    labelColor = '#ffc0cb8c'
                    label = 'Söküm Listesinde'
                    break;
                default:
                    labelColor = ''
                    label = ''
                    break;
            }

   

            return [
                labelColor,
                label
            ]
        },

        sil({ id }){
            this.$http.post('/apartman/customerSet', {id})
            notify.success('Başarılı')
            this.loadPage()
            this.$emit('loadItems');
        },

        expiredate(obj){

            const hedefTarih = new Date(obj); 
            const bugun = new Date();
            const farkMs = hedefTarih - bugun;
            const farkGun = Math.ceil(farkMs / (1000 * 60 * 60 * 24));

            return  this.formatDate(obj, "DD.MM.YYYY HH:mm") + ` (${farkGun} Gün)`
        },
    },
}; 
</script>  

<template>
    <b-modal id="client-list-scoped" size="xl" :title="`${name} > Apartman Sistemindeki Müşterileri`"  no-close-on-backdrop hide-footer>
        <Datatable 
            :columns="columns" 
            :tableData="tableData" 
            @search-query="reLoadPage"
            @sort-column="handleSortColumn"
            @page-change="pageChange"
            :sort="sort"
            :loading="isLoading"
            :poading="pageLoading"
            :tableDataLoad="pagination">

            <template #expiredate="{ row }">
              <div v-html="expiredate(row.expiredate)"></div>
              <div>{{ label(row.status)[1] }}</div>
            </template>
            
            <template #username="{ row }">
              <span :style="`padding:50px 10px;background-color:${ row.online ? '#7eff7e' : '' }`">{{  row.username }}</span>
            </template>

            <template #fullname="{ row }">
              <span :style="`padding:50px 10px;background-color:${ label(row.status)[0] }`">{{  row.fullname }}</span>
            </template>
            
            <template #button="{ row }">
                <button 
                    type="button" 
                    class="btn btn-danger btn-sm" 
                    @click="sil(row)"> Listeden Çıkart
                    </button>
            </template>
        </Datatable>
    </b-modal>
</template>